import type { RouteObject } from 'react-router';

import { BASE } from 'common/src/routes/BaseRoutes';

import UserSettingsPage from 'portal/src/pages/userSettings/UserSettingsPage';

const UserSettingsRoute: RouteObject = {
  path: BASE.USER_SETTINGS,
  element: <UserSettingsPage />,
};

export default UserSettingsRoute;
